import IconWrapper from "./iconWrapper.atom";

export default IconWrapper;
